import React from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

const pillClassMap: Record<string, string> = {
  Draft:            'pill pill-draft',
  'In Progress':    'pill pill-inprogress',
  Sent:             'pill pill-sent',
  Accepted:         'pill pill-accepted',
  Rejected:         'pill pill-rejected',
  Closed:           'pill pill-closed',
  Expired:          'pill pill-expired',
  Cancelled:        'pill pill-cancelled',
  Available:        'pill pill-accepted',
  Unavailable:      'pill pill-rejected',
  Pending:          'pill pill-sent',
  Ready:            'pill pill-accepted',
  Coverage_Failed:  'pill pill-rejected',
  Active:           'pill pill-accepted',
  Inactive:         'pill pill-cancelled',
};

const labelDisplayMap: Record<string, string> = {
  Coverage_Failed: 'Coverage Failed',
  'In Progress': 'In Progress',
};

interface BadgeProps {
  label: string;
  variant?: BadgeVariant;
}

export const Badge: React.FC<BadgeProps> = ({ label }) => {
  const cls = pillClassMap[label] ?? 'pill pill-draft';
  const displayLabel = labelDisplayMap[label] ?? label;
  return <span className={cls}>{displayLabel}</span>;
};

export const Pill = Badge;
